<label [class.g-required]="required"><ng-content></ng-content>{{ currencyLabel ? ', ' + currency : '' }}</label>
